var baseURL = "/rightholder";
var tracks = baseURL + "/tracks";
var earnings = baseURL + "/earnings";
export var rightholder = {
    home: function () { return tracks; },
    tracks: {
        index: function () { return tracks; },
    },
    earnings: {
        index: function () { return earnings; },
    },
};
